"use client"
import { motion } from "framer-motion"
import { GoogleAd } from "../ads/GoogleAd";
import { useScreen } from "../../contexts/screen.provider";
import { DashboardAnalyticsCard } from "./dashboard-analytics";
import { BookOpen, PlayCircle, Target, Users } from "lucide-react";

const Dashboard = () => {
  const { isMobile } = useScreen()
  return (
    <div className="h-full w-full py-4   bg-white dark:bg-[#212121]/90">
      <div className="w-full  mx-auto">      {/* Header Section */}
        {/* Stats Cards */}
        <DashboardAnalyticsCard isDashboarad />
        {
          isMobile && <GoogleAd />
        }
        {/* YouTube Video Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, ease: "easeOut", delay: 0.2 }}
          className="w-full mt-12 mb-8"
        >
          <div className="bg-gradient-to-br from-white to-gray-50/50 dark:from-[#212121]/85 dark:to-[#212121]/80 rounded-2xl p-8 border border-gray-200/50 dark:border-gray-700/50 shadow-sm">
            {/* Header Section */}
            <div className="text-center mb-8">
              <div className="flex items-center justify-center gap-2 mb-4">
                <PlayCircle className="h-8 w-8 text-accent-600 dark:text-accent-400" />
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white">New to Interview Preparation?</h2>
              </div>
              <p className="text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
                Watch this comprehensive guide to learn how to effectively use our platform and master your interview
                skills in under 10 minutes.
              </p>
            </div>

            {/* Video Container */}
            <div className="relative w-full max-w-4xl mx-auto mb-8">
              <div className="relative w-full aspect-video rounded-xl overflow-hidden shadow-lg">
                <iframe
                  className="w-full h-full"
                  src="https://www.youtube.com/embed/ttZQpttX8VY"
                  title="HOW to PREPARE for a JOB INTERVIEW in under 10 MINUTES!!"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                />
              </div>
            </div>

            {/* Feature Highlights */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="flex items-start gap-3 p-4 bg-blue-50 dark:bg-blue-900/20 rounded-xl">
                <Users className="h-6 w-6 text-blue-600 dark:text-blue-400 mt-1 flex-shrink-0" />
                <div>
                  <h3 className="font-semibold text-gray-900 dark:text-white mb-1">Track Progress</h3>
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    Monitor your interview performance and see detailed analytics of your improvement over time.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3 p-4 bg-green-50 dark:bg-green-900/20 rounded-xl">
                <BookOpen className="h-6 w-6 text-green-600 dark:text-green-400 mt-1 flex-shrink-0" />
                <div>
                  <h3 className="font-semibold text-gray-900 dark:text-white mb-1">Practice Sessions</h3>
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    Access structured practice sessions tailored to different job positions and skill levels.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3 p-4 bg-purple-50 dark:bg-purple-900/20 rounded-xl">
                <Target className="h-6 w-6 text-purple-600 dark:text-purple-400 mt-1 flex-shrink-0" />
                <div>
                  <h3 className="font-semibold text-gray-900 dark:text-white mb-1">Get Insights</h3>
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    Receive personalized feedback and actionable tips to improve your interview performance.
                  </p>
                </div>
              </div>
            </div>

            {/* Call to Action */}
            <div className="text-center mt-8 pt-6 border-t border-gray-200 dark:border-gray-700">
              <p className="text-sm text-gray-500 dark:text-gray-400">
                Ready to start your interview preparation journey? Your dashboard above shows your current progress and
                areas for improvement.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  )
}

export default Dashboard
